"use strict";
/*  Profile View
*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileView = void 0;
var lit_html_1 = require("lit-html");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var baseStyles_1 = require("./baseStyles");
var ChatWithMe_1 = require("./ChatWithMe");
var FriendList_1 = require("./FriendList");
var presenter_1 = require("./presenter");
var CVPresenter_1 = require("./CVPresenter"); // 20210527
var ProfileCard_1 = require("./ProfileCard");
var CVCard_1 = require("./CVCard");
var QRCodeCard_1 = require("./QRCodeCard");
var addMeToYourFriends_1 = require("./addMeToYourFriends");
var ProfileView = function (subject, context) {
    var profileBasics = (0, presenter_1.presentProfile)(subject, context.session.store); // rdflib rdfs type problems
    var rolesByType = (0, CVPresenter_1.presentCV)(subject, context.session.store);
    var styles = {
        grid: (0, style_map_js_1.styleMap)(__assign(__assign(__assign({}, (0, baseStyles_1.responsiveGrid)()), (0, baseStyles_1.paddingSmall)()), { background: "radial-gradient(circle, ".concat(profileBasics.backgroundColor, " 80%, ").concat(profileBasics.highlightColor, " 100%)") })),
        card: (0, style_map_js_1.styleMap)((0, baseStyles_1.card)()),
        chat: (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.card)()), (0, baseStyles_1.padding)())),
    };
    return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    <div style=\"", "\">\n      <div>\n        <div data-testid=\"profile-card\" style=\"", "\">\n          ", "\n          ", "\n        </div>\n      </div>\n      <div data-testid=\"friend-list\" style=\"", "\">\n        ", "\n      </div>\n      <div data-testid=\"curriculum-vitae\" style=\"", "\">\n        ", "\n      </div>\n      <div style=\"", "\">", "</div>\n      <div data-testid=\"qrcode-display\" style=\"", "\">\n        ", "\n      </div>\n\n    </div>\n  "], ["\n    <div style=\"", "\">\n      <div>\n        <div data-testid=\"profile-card\" style=\"", "\">\n          ", "\n          ", "\n        </div>\n      </div>\n      <div data-testid=\"friend-list\" style=\"", "\">\n        ", "\n      </div>\n      <div data-testid=\"curriculum-vitae\" style=\"", "\">\n        ", "\n      </div>\n      <div style=\"", "\">", "</div>\n      <div data-testid=\"qrcode-display\" style=\"", "\">\n        ", "\n      </div>\n\n    </div>\n  "])), styles.grid, styles.card, (0, ProfileCard_1.ProfileCard)(profileBasics), (0, addMeToYourFriends_1.addMeToYourFriendsDiv)(subject, context), styles.card, (0, FriendList_1.FriendList)(subject, context), styles.card, (0, CVCard_1.CVCard)(profileBasics, rolesByType), styles.chat, (0, ChatWithMe_1.ChatWithMe)(subject, context), styles.card, (0, QRCodeCard_1.QRCodeCard)(profileBasics, subject));
};
exports.ProfileView = ProfileView;
var templateObject_1;
//# sourceMappingURL=ProfileView.js.map